import { AlertDialog, AlertDialogContent } from '@/components/ui/alert-dialog';
import { BlockButton } from '@/components/BlockButton';
import useBulkDestroyCandidateProfiles from '../api/useBulkDestroyCandidateProfiles';
import { showSuccessToast, showErrorToast } from '../../job_change_processes/lib/toast';

type Props = {
  ids: number[];
  candidateNames: string[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
};

export default function BulkDeleteConfirmModal({
  ids,
  candidateNames,
  open,
  onOpenChange,
  onSuccess,
}: Props) {
  const { mutateAsync: bulkDestroy, isPending } = useBulkDestroyCandidateProfiles();

  const handleDelete = async () => {
    try {
      await bulkDestroy({ ids });
      showSuccessToast(`${ids.length}件の求職者を削除しました`);
      onSuccess();
    } catch {
      showErrorToast('削除に失敗しました');
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="w-[728px]">
        <div className="flex items-center justify-between border-b border-solid border-border px-6 py-4">
          <p className="text-base font-bold">求職者データの削除</p>
        </div>
        <div className="flex flex-col gap-4 p-6">
          <p className="text-base">以下の求職者を削除してよろしいですか？</p>
          <div className="flex items-center gap-2 rounded border border-solid border-border bg-gray-100 px-4 py-3">
            <span className="flex size-6 items-center justify-center rounded-full border border-solid border-border bg-white text-xs font-bold">
              {ids.length}
            </span>
            <span className="text-sm">{candidateNames.join(', ')}</span>
          </div>
        </div>
        <div className="flex items-center justify-end gap-4 border-t border-solid border-border px-6 py-4">
          <div className="w-[94px]">
            <BlockButton
              type="button"
              colorType="white"
              text="キャンセル"
              onClick={() => onOpenChange(false)}
            />
          </div>
          <div className="w-[108px]">
            <BlockButton
              type="button"
              colorType="red"
              text="削除する"
              onClick={handleDelete}
              disabled={isPending}
            />
          </div>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
